<template>
    <div id="infoDetails">
        <el-dialog
        title="详情"
        :visible.sync="dialogVisible"
        width="30%"
        center
        :close-on-click-modal="false"
        :show-close="false">
            <div class="closeBtn" @click="handleClose"><img src="../../assets/BackManagement/organization/close.png" alt=""></div>
            <div class="content">
                <div class="title">{{details.title}}</div>
                <div class="time"><span>文章来源：{{details.name}}</span> <span>发布时间：{{details.releaseTime}}</span> </div>
                <div v-show="typeId==1" class="img">
                    <img id="litpic" v-if="litpicIsShow" :src="litpic" alt="">
                    <img id="litpic" v-else src="../../assets/BackManagement/organization/err1.png" alt="">
                </div>
                <div v-show="typeId==1" class="con" v-html="details.description"></div>
                <div class="info-content" v-show="typeId==2">
                    <iframe
                            style="border:none;width: 100%;height: 100%"
                            v-bind:src="link"
                    ></iframe>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import SocialNewsManagementService from '../../jaxrs/concrete/com.zny.eop.socialServiceOss.api.SocialNewsManagementService.js';
import OnlineLeaningService from '../../jaxrs/concrete/com.zny.eop.socialServiceOss.api.OnlineLeaningService.js';
import eventBus from "../../eventBus";
export default {
    data(){
        return{
            id:"",
            num:"",
            typeId:0,//1:图文，2：超链接
            link:"",
            litpic:"",
            litpicIsShow:true,
            details:{},
            dialogVisible:false,
        }
    },
    watch:{
        // 监听人脸图片
        litpic: function() {
            var that = this
            that.$nextTick(function(){
                /*现在数据已经渲染完毕*/
                document.getElementById("litpic").onerror = function () {
                    that.litpicIsShow=false
                }
            })
        },
    },
    mounted(){
        this.onload()
    },
    methods:{
        onload(){
            var that = this
            //编辑
            eventBus.$on('infoDetailsOpen',function (id,typeId,num) {//num：1：资讯 2：在线学习
                that.id=id
                that.num=num
                that.typeId=typeId
                that.dialogVisible=true
                if(num==1){
                    that.forDetails()
                }else if(num==2){
                    that.forDetails1()
                }
               
            })
        },
        forDetails(){
            SocialNewsManagementService.socialNewsInformationInfo(this.id)
            .then((res)=>{
                // console.log(res)
                this.litpic=res.litpic
                this.link=res.link
                this.details=res
            })
        },
        forDetails1(){
            OnlineLeaningService.onlineLeaningInfo(this.id)
            .then((res)=>{
                console.log(res)
                this.litpic=res.picture
                this.link=res.link
                this.details=res
            })
        },
        // 关闭弹窗
        handleClose(){
            this.dialogVisible=false
        },
    },
}
</script>
<style lang="less">
@import '../../viewsStyle/BackManagement/infoDetails.less';

</style>